import { Card, SectionHeader, DeltaChip } from "../../components/lib";
import { GROWTH_KPIS } from "../../mocks/growthData";

export default function GrowthOverview() {
  return (
    <div className="space-y-6" data-testid="gr-overview">
      <Card testId="gr-kpis">
        <SectionHeader eyebrow="Growth" title="North-star metrics" />
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {GROWTH_KPIS.map((k) => (
            <div key={k.key} data-testid={`gr-kpi-${k.key}`}>
              <div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>{k.label}</div>
              <div className="text-xl font-semibold tabular-nums mt-1 inline-flex items-center gap-2" style={{ color: "var(--ph-ink-strong)" }}>
                {k.value} <DeltaChip delta={k.delta} trend={k.trend} />
              </div>
              {k.hint && <div className="text-[10px] mt-0.5" style={{ color: "var(--ph-ink-muted)" }}>{k.hint}</div>}
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
